import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Incoming: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEmail2Incoming"><Path fillRule="evenodd" clipRule="evenodd" d="M22 9.11816L12 14.1182L4 10.1172V18H12V20H2V4H22V9.11816Z" fill="currentColor"/><Path d="M19.707 14.207L17.9141 16H23V18H17.9141L19.707 19.793L18.293 21.207L14.0859 17L18.293 12.793L19.707 14.207Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Incoming;
